import { type Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row, theme } from 'antd';
import { PosInput } from 'pos-client/components/shared/Form/PosInput.tsx';
import type { RMAssetFormType } from 'pos-shared/models/resourceManagementSchema.ts';

interface AvailabilityTabContentProps {
  control: Control<RMAssetFormType>;
}

const AvailabilityTabContent = ({ control }: AvailabilityTabContentProps) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <>
      <Row gutter={[token.marginXL, token.marginXL]}>
        <Col span={12}>
          <PosInput
            control={control}
            label={t('scheduling.availability.earliestStartTime')}
            name="startTimeWindow.start"
            readOnly
          />
        </Col>
        <Col span={12}>
          <PosInput
            control={control}
            label={t('scheduling.availability.latestStartTime')}
            name="startTimeWindow.end"
            readOnly
          />
        </Col>
      </Row>

      <Row gutter={[token.marginXL, token.marginXL]}>
        <Col span={12}>
          <PosInput
            control={control}
            label={t('scheduling.availability.earliestEndTime')}
            name="finishTimeWindow.start"
            readOnly
          />
        </Col>
        <Col span={12}>
          <PosInput
            control={control}
            label={t('scheduling.availability.latestEndTime')}
            name="finishTimeWindow.end"
            readOnly
          />
        </Col>
      </Row>
      <Row gutter={[token.marginXL, token.marginXL]}>
        <Col span={12}>
          <PosInput
            control={control}
            label={t('scheduling.availability.earliestServiceTime')}
            name="serviceTimeWindow.start"
            readOnly
          />
        </Col>
        <Col span={12}>
          <PosInput
            control={control}
            label={t('scheduling.availability.latestServiceTime')}
            name="serviceTimeWindow.end"
            readOnly
          />
        </Col>
      </Row>
    </>
  );
};

export default AvailabilityTabContent;
